let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("811la")).then(() => parcelRequire('dV8me'));